import { Color } from '@superdispatch/ui';
import { createSvgIcon } from 'shared/icons/IconUtils';

export const LightBulb = createSvgIcon(
  'LightBulb',
  <path
    d="M7.99996 3.99984C9.06083 3.99984 10.0782 4.42126 10.8284 5.17141C11.5785 5.92156 12 6.93897 12 7.99984C12 9.47984 11.1933 10.7732 9.99996 11.4665V12.6665C9.99996 12.8433 9.92972 13.0129 9.8047 13.1379C9.67967 13.2629 9.5101 13.3332 9.33329 13.3332H6.66663C6.48982 13.3332 6.32025 13.2629 6.19522 13.1379C6.0702 13.0129 5.99996 12.8433 5.99996 12.6665V11.4665C4.80663 10.7732 3.99996 9.47984 3.99996 7.99984C3.99996 6.93897 4.42139 5.92156 5.17153 5.17141C5.92168 4.42126 6.93909 3.99984 7.99996 3.99984ZM9.33329 13.9998V14.6665C9.33329 14.8433 9.26305 15.0129 9.13803 15.1379C9.01301 15.2629 8.84344 15.3332 8.66663 15.3332H7.33329C7.15648 15.3332 6.98691 15.2629 6.86189 15.1379C6.73686 15.0129 6.66663 14.8433 6.66663 14.6665V13.9998H9.33329ZM13.3333 7.33317H15.3333V8.6665H13.3333V7.33317ZM0.666626 7.33317H2.66663V8.6665H0.666626V7.33317ZM8.66663 0.666504V2.6665H7.33329V0.666504H8.66663ZM3.27996 2.33317L4.69996 3.75984L3.75329 4.69984L2.33329 3.2865L3.27996 2.33317ZM11.3 3.75317L12.7133 2.33317L13.6666 3.2865L12.2466 4.69984L11.3 3.75317Z"
    fill="#5B6371"
  />,
  {
    viewBox: '0 0 16 16',
    width: '12px',
    height: '12px',
    htmlColor: Color.Dark100,
    fill: 'none',
  },
);
